// What every screen does when it appears: sets the document title and, once the visit has moved to another
// page, announces the new page and moves focus to the main area, so that a keyboard or screen reader user does
// not stay on a navigation link of the page they left (WCAG 2.4.3). The first page of a visit is announced by
// the browser itself, and React's development double run of effects must not count as a second page.

import { useEffect } from "react";
import { t } from "../../lib/i18n";
import { useAnnounce } from "./LiveRegion";

export const MAIN_ID = "inhalt";

/** The page title last handled; undefined until the first page of the visit has appeared. */
let currentPage: string | undefined;

export function usePageTitle(page: string): void {
  const announce = useAnnounce();
  useEffect(() => {
    document.title = t("app.title", { page });
    const previous = currentPage;
    currentPage = page;
    if (previous === undefined || previous === page) return;
    announce(t("shell.announce", { page }));
    document.getElementById(MAIN_ID)?.focus({ preventScroll: true });
  }, [announce, page]);
}
